export default "__VITE_ASSET__fQC7OWIw__"